import { useFetchUserData } from 'queries/auth/user';

export type FeatureCode =
  | 'multi_branch'
  | 'kitchen_display'
  | 'table_orders'
  | 'advanced_reports'
  | 'loyalty'
  | 'expiry_alerts'
  | 'advanced_inventory'
  | 'api_access'
  | 'inpatient_ipd';

export const useFeatureGate = () => {
  const { userData } = useFetchUserData();

  const hasFeature = (feature: FeatureCode): boolean => {
    if (!userData) return true;

    const roleName = (userData?.role || userData?.role_name || '').toLowerCase();
    const isAdminOrOwner =
      userData?.is_super_admin ||
      roleName.includes('super') ||
      roleName.includes('admin') ||
      roleName.includes('owner') ||
      roleName.includes('manager');

    const subStatus = (
      userData?.subscription_status ||
      userData?.subscription?.status ||
      userData?.plan_status ||
      ''
    ).toLowerCase();

    const isSubscribed =
      userData?.is_subscribed === true ||
      ['active', 'trialing', 'paid', 'subscribed', 'premium'].includes(subStatus) ||
      isAdminOrOwner;

    if (isSubscribed) {
      return true;
    }

    const allowed = userData?.allowed_features || [];
    return allowed.includes(feature);
  };

  return { hasFeature, allowedFeatures: userData?.allowed_features || [] };
};
